import React, { Component } from "react";
import { FormGroup, Input } from "reactstrap";
import { generateUiAttributeAddressText } from "../Utils";

class AddressAttribute extends Component {
  static getDisplayValue(attributeValue) {
    return attributeValue.valueAddress
      ? generateUiAttributeAddressText(attributeValue.valueAddress)
      : null;
  }

  static getDisplayValueText(attributeValue) {
    return attributeValue.valueAddress
      ? attributeValue.valueAddress.text
      : null;
  }

  static getDisplayValueInFilter(av) {
    return av.valueAddress ? av.valueAddress.room : null;
  }

  handleKeyDown = (e, fieldIndex) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (this.props.onEnterKey) {
        this.props.onEnterKey(fieldIndex);
      }
    }
  };

  render() {
    let { attributeValue, setData, registerFieldRef } = this.props;

    attributeValue.valueAddress = attributeValue.valueAddress || {};
    let addressVal = attributeValue.valueAddress;
    return (
      <div>
        <div className="d-flex">
          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.room}
            onChange={(e) => {
              attributeValue.valueAddress.room = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Room"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 0)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(0, ref)}
          />

          <Input
            className="my-1 ui-attribute-el"
            value={addressVal.floor}
            onChange={(e) => {
              attributeValue.valueAddress.floor = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Floor"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 1)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(1, ref)}
          />
        </div>
        <div className="d-flex">
          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.line ? addressVal.line[0] : ""}
            onChange={(e) => {
              attributeValue.valueAddress.line =
                attributeValue.valueAddress.line || [];
              attributeValue.valueAddress.line[0] = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Address Line 1"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 2)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(2, ref)}
          />

          <Input
            className="my-1 ui-attribute-el"
            value={addressVal.line ? addressVal.line[1] : ""}
            onChange={(e) => {
              attributeValue.valueAddress.line =
                attributeValue.valueAddress.line || [];
              attributeValue.valueAddress.line[1] = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Address Line 2"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 3)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(3, ref)}
          />
        </div>
        <div className="d-flex">
          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.city}
            onChange={(e) => {
              attributeValue.valueAddress.city = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="City"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 4)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(4, ref)}
          />

          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.county}
            onChange={(e) => {
              attributeValue.valueAddress.county = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="County"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 5)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(5, ref)}
          />

          <Input
            className="my-1 ui-attribute-el"
            value={addressVal.district}
            onChange={(e) => {
              attributeValue.valueAddress.district = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="District"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 6)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(6, ref)}
          />
        </div>

        <div className="d-flex">
          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.state}
            onChange={(e) => {
              attributeValue.valueAddress.state = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="State"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 7)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(7, ref)}
          />

          <Input
            className="mr-2 my-1 ui-attribute-el"
            value={addressVal.postalCode}
            onChange={(e) => {
              attributeValue.valueAddress.postalCode = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Postal Code"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 8)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(8, ref)}
          />

          <Input
            className="my-1 ui-attribute-el"
            value={addressVal.country}
            onChange={(e) => {
              attributeValue.valueAddress.country = e.target.value;
              setData(attributeValue);
            }}
            type="text"
            placeholder="Country"
            onBlur={this.props.onBlur}
            onKeyDown={(e) => this.handleKeyDown(e, 9)}
            innerRef={(ref) => registerFieldRef && registerFieldRef(9, ref)}
          />
        </div>
      </div>
    );
  }
}

export default AddressAttribute;
